export default {
    //提问
    getAsk (params) {
        return new Promise((resolve, reject) => {
            axios.get('/api/ask/my-questions', {
                params:params 
            })
            .then((response) => {
                resolve(response)
            })
        }, err => {
            reject(err)
        })
    },
    //回答
    getAnswer (params) {
        return new Promise((resolve, reject) => {
            axios.get('/api/ask/my-answers',{
                params:params
            })
            .then((response) => {
                resolve(response)
            })
        }, err => {
            reject(err)
        })
    },
    //草稿
    getDraft (params) {
        return new Promise((resolve, reject) => {
            axios.get('/api/ask/my-drafts',{
                params:params
            })
            .then((response) => {
                resolve(response)
            })
        }, err => {
            reject(err)
        })
    },
    delAsk(id){
     return new Promise((resolve, reject) => {
        axios.delete('/api/ask-answer/'+ id +'/delete')
        .then((response) => {
            resolve(response)
        })
    }, err => {
        reject(err)
    }) 
 },
 delQuestion(id){
     return new Promise((resolve, reject) => {
        axios.delete('/api/ask-question/'+ id +'/delete')
        .then((response) => {
            resolve(response)
        })
    }, err => {
        reject(err)
    }) 
 },
 delDefault(id){
     return new Promise((resolve, reject) => {
        axios.delete('/api/ask-draft/'+ id +'/delete')
        .then((response) => {
            resolve(response)
        })
    }, err => {
        reject(err)
    }) 
 },
}